<div class="video_full_screen">

    <video playsinline autoplay #videoFineLivello (ended)="fineVideo()" [poster]="'https://conad.s3.eu-south-1.amazonaws.com/assets/video/fine_livello'+((mondo != '1')?('_mondo_'+mondo):'')+'/poster_'+appService.authUser?.avatar?.code+'_fine_livello_'+livello+'.jpg'">
        <source [src]="'https://conad.s3.eu-south-1.amazonaws.com/assets/video/fine_livello'+((mondo != '1')?('_mondo_'+mondo):'')+'/'+appService.authUser?.avatar?.code+'_fine_livello_'+livello+'.mp4'" type="video/mp4">
    </video>

</div>
